import { loadingAppsTable } from '@/containers/applications/table'
import { useConvocatoria } from '@/hooks/useConvocatoria'
import { EApplicationType } from '@/interfaces'
import { ApplicationsState, AuthState, ConvocatoriasState } from '@/state'
import { Button, Row, Tooltip } from 'antd'
import { FaTools } from 'react-icons/fa'
import { FaCity } from 'react-icons/fa6'
import { GiFruitTree } from 'react-icons/gi'

export default function ConvocatoriaAddApplication() {
  const {
    loading,
    newRuralLivingApplication,
    newUrbanLivingApplication,
    newUpgradeApplication,
  } = useConvocatoria()

  if (
    !AuthState.userPermissions.value.CSolicitud?.create ||
    loadingAppsTable.value
  )
    return null

  if (ApplicationsState.canCreateApplication.value)
    return (
      <Row className='convocatoria-add-actions'>
        {ConvocatoriasState.currentConvocatoria.value.appType?.includes(
          EApplicationType.URBAN_LIVING
        ) && (
          <Tooltip title='Vivienda Urbana'>
            <Button
              loading={loading.value.urbanLiving}
              shape='circle'
              icon={<FaCity />}
              onClick={newUrbanLivingApplication}
              disabled={loading.value.improve || loading.value.ruralLiving}
            />
          </Tooltip>
        )}
        {ConvocatoriasState.currentConvocatoria.value.appType?.includes(
          EApplicationType.RURAL_LIVING
        ) && (
          <Tooltip title='Vivienda Rural'>
            <Button
              loading={loading.value.ruralLiving}
              shape='circle'
              icon={<GiFruitTree />}
              onClick={newRuralLivingApplication}
              disabled={loading.value.improve || loading.value.urbanLiving}
            />
          </Tooltip>
        )}
        {ConvocatoriasState.currentConvocatoria.value.appType?.includes(
          EApplicationType.IMPROVEMENT
        ) && (
          <Tooltip title='Mejora de vivienda'>
            <Button
              loading={loading.value.improve}
              shape='circle'
              icon={<FaTools />}
              onClick={newUpgradeApplication}
              disabled={loading.value.ruralLiving || loading.value.urbanLiving}
            />
          </Tooltip>
        )}
      </Row>
    )

  return null
}
